<template>
  <div class="tab-content account-info-root">
    <div>
      <el-table :data="tableData" row-key="key">
        <el-table-column prop="type" label="发票送达">
          <template slot-scope="scope">
            <div class="table-content">
              <template v-if="scope.row.edit">
                <div class="input-layout">
                  <el-input size="small" v-model="scope.row.instructions" />
                </div>
              </template>
              <template v-else>{{ scope.row.instructions }}</template>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="勋章" width="100">
          <template slot-scope="scope">
            <div class="table-content">
              <template v-if="scope.row.edit">
                <div
                  v-if="!scope.row.medalPicture"
                  class="upload-image"
                  @click="handleUpload(scope.$index)"
                >
                  <div class="image-wrap">
                    <el-image :src="AddIcon" />
                  </div>
                </div>
                <div v-else class="table-cell-pic-wrap">
                  <el-image
                    :ref="`ref${scope.$index}`"
                    :src="scope.row.medalPicture"
                    class="table-cell-pic"
                    :initial-index="0"
                    :preview-src-list="[scope.row.medalPicture]"
                  />
                  <div class="preview">
                    <el-image
                      :src="SeeIcon"
                      class="btn-icon"
                      @click="handlePreview(`ref${scope.$index}`)"
                    />
                    <el-image
                      :src="DelIcon"
                      class="btn-icon"
                      @click="handleDeleteImage(scope.$index)"
                    />
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="table-cell-pic-wrap" v-if="scope.row.medalPicture">
                  <el-image
                    :ref="`ref${scope.$index}`"
                    :src="scope.row.medalPicture"
                    class="table-cell-pic"
                    :initial-index="0"
                    :preview-src-list="[scope.row.medalPicture]"
                  />
                  <div class="preview">
                    <el-image
                      :src="SeeIcon"
                      class="btn-icon"
                      @click="handlePreview(`ref${scope.$index}`)"
                    />
                  </div>
                </div>
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="勋章名称" width="120">
          <template slot-scope="scope">
            <div class="table-content">
              <template v-if="scope.row.edit">
                <div class="input-layout">
                  <el-input size="small" v-model="scope.row.medalName" />
                </div>
              </template>
              <template v-else>{{ scope.row.medalName }}</template>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="竞争力" width="120">
          <template slot-scope="scope">
            <div class="table-content">
              <template v-if="scope.row.edit">
                <div class="input-layout">
                  <el-input size="small" v-model="scope.row.competitivePower" />
                </div>
              </template>
              <template v-else>{{ scope.row.competitivePower }}</template>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="排序" width="80">
          <template slot-scope="scope">
            <div class="table-content">
              <template v-if="scope.row.edit">
                <div class="input-layout">
                  <el-input size="small" v-model="scope.row.sort" />
                </div>
              </template>
              <template v-else>{{ scope.row.sort }}</template>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <div class="row">
              <template v-if="scope.row.edit">
                <el-button type="text" @click="handleSave(scope.$index)"
                  >保存</el-button
                >
                <el-button type="text" @click="handleCancel(scope.$index)"
                  >取消</el-button
                ></template
              >
              <template v-else>
                <el-button
                  type="text"
                  @click="handleEdit(scope.$index)"
                  :disabled="isEdit"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  @click="handleDelete(scope.$index)"
                  :disabled="isEdit"
                  >删除</el-button
                >
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="add-layout">
      <el-button
        type="text"
        icon="el-icon-plus"
        @click="handleAdd"
        :disabled="isEdit"
        >新增</el-button
      >
    </div>

    <UploadImageView
      ref="imgupload"
      request-id="1"
      :imgType="imgType"
      @upload="uploadSubmit"
    />
  </div>
</template>

<script>
import UploadImageView from "@/views/businessManage/checkShop/components/UploadImage.vue";
const IConst_See_Icon = require("@/assets/zz/see-icon.png");
const IConst_Del_Icon = require("@/assets/zz/del-icon.png");
const IConst_Add_Icon = require("@/assets/zz/add-icon.png");

import { generateUUId } from "@/views/businessManage/checkShop/util/ViewHelp";
import { IndicatorInfoHelp } from "./help";
import _ from "lodash";

import {
  getIndicatorInfo,
  updateIndicatorInfo,
  deleteIndicatorInfo,
} from "@/api/platform/index.js";

export default {
  components: { UploadImageView },
  props: {
    type: {
      type: String,
    },
  },
  data() {
    return {
      SeeIcon: IConst_See_Icon,
      DelIcon: IConst_Del_Icon,
      AddIcon: IConst_Add_Icon,

      imgType: "",

      /**
       * {
    "id": "1717160192084725761",
    "type": "OPEN_ACCOUNT",
    "instructions": "仅纸质版开户，客户必须先邮寄纸质版，收到纸质版资料再开户",
    "medalFlag": "yes",
    "competitivePower": 1,
    "sort": 4,
    "liquidatedDamages": null,
    "logisticsCompanyCode": null,
    "receivingNode": null

    key:"",
    edit:false,
}
       */
      tableData: [],
    };
  },
  created() {
    this.doLoadIndicatorInfo();
  },
  computed: {
    isEdit() {
      if (this.tableData.some((item) => item.edit)) {
        return true;
      }
      return false;
    },
  },
  methods: {
    doLoadIndicatorInfo() {
      getIndicatorInfo(this.type).then((data) => {
        if (data instanceof Array && data.length > 0) {
          this.tableData = data.map((item) => {
            item.edit = false;
            item.key = generateUUId();
            return item;
          });
        } else {
          this.tableData = [];
        }
      });
    },
    updataIndicatorInfo(index) {
      const item = this.tableData[index];
      let data = _.cloneDeep(item);
      data.type = this.type;
      updateIndicatorInfo(data).then((data) => {
        this.$message.success("保存成功");
        this.doLoadIndicatorInfo();
      });
    },
    handleSave(index) {
      const item = this.tableData[index];
      if (!item.instructions && !item.competitivePower && !item.sort) {
        this.$message.warning("输入字段不能全部为空");
        return;
      }
      this.updataIndicatorInfo(index);
    },
    handleCancel(index) {
      const item = this.tableData[index];
      item.edit = false;
      if (!item.id) {
        this.tableData.splice(index, 1);
      }
    },
    handleEdit(index) {
      const item = this.tableData[index];
      item.edit = true;
    },
    handleDelete(index) {
      this.$confirm("确认删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const item = this.tableData[index];
          if (item.id) {
            deleteIndicatorInfo(item.id).then(() => {
              this.$message.success("删除记录成功");

              this.doLoadIndicatorInfo();
            });
          } else {
            this.tableData.splice(index, 1);
          }
        })
        .catch(() => {
          //
        });
    },
    handleUpload(index) {
      this.$refs.imgupload.open(index);
    },
    uploadSubmit(obj) {
      const { type, url } = obj;
      const item = this.tableData[type];
      item.medalPicture = url;
      item.key = generateUUId();
    },
    handlePreview(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].showViewer = true;
      }
    },
    handleDeleteImage(index) {
      const item = this.tableData[index];
      item.medalPicture = "";
      item.key = generateUUId();
    },
    handleAdd() {
      const item = IndicatorInfoHelp.newItem();
      this.tableData.push(item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/index.scss";

.account-info-root {
  .add-layout {
  }
}
</style>
